export const DISCORD_URL = "https://discord.gg/cgvcTFXH5d";
export const WHATSAPP_URL = "https://chat.whatsapp.com/GwYF34utsnl5yocdiQJc5S";
export const APK_DOWNLOAD_URL = "https://cdn.runeria.fun/OriginPS.apk";
export const SERVER_IP = "149.202.58.185";
export const SERVER_DOMAINS = ["www.growtopia1.com", "www.growtopia2.com"];

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "https://originps.net";

// Plain-text config URLs (used by Powertunnel / Surge)
export const RAW_HOSTS_URL = `${BACKEND_URL}/api/raw/OriginPS`;
export const IOS_SURGE_URL = `${BACKEND_URL}/api/ios/OriginPS`;

// Forced-download endpoints
export const DOWNLOAD_WINDOWS_HOSTS = `${BACKEND_URL}/api/download/hosts.txt`;
export const DOWNLOAD_ANDROID_HOSTS = `${BACKEND_URL}/api/download/OriginPS.txt`;
export const DOWNLOAD_IOS_SURGE = `${BACKEND_URL}/api/download/OriginPS.conf`;
